import schema from "../../gen/schema/witbooking.backoffice.extra.v1/Extra.json";

schema.properties.restrictions.properties.availability.properties.value.$ref = "#/definitions/witbooking.backoffice.extra.v1.RestrictionValue";
schema.properties.restrictions.properties.blockage.properties.value.$ref = "#/definitions/witbooking.backoffice.extra.v1.RestrictionValue";
schema.properties.restrictions.properties.minStay.properties.value.$ref = "#/definitions/witbooking.backoffice.extra.v1.RestrictionValue";
schema.properties.restrictions.properties.maxStay.properties.value.$ref = "#/definitions/witbooking.backoffice.extra.v1.RestrictionValue";
schema.properties.restrictions.properties.minNotice.properties.value.$ref = "#/definitions/witbooking.backoffice.extra.v1.RestrictionValue";
schema.properties.restrictions.properties.maxNotice.properties.value.$ref = "#/definitions/witbooking.backoffice.extra.v1.RestrictionValue";
schema.properties.restrictions.properties.code.properties.value.$ref = "#/definitions/witbooking.backoffice.extra.v1.RestrictionValue";
schema.properties.restrictions.properties.bookingWindow.properties.value.$ref = "#/definitions/witbooking.backoffice.extra.v1.RestrictionValue";
schema.properties.restrictions.properties.travelWindow.properties.value.$ref = "#/definitions/witbooking.backoffice.extra.v1.RestrictionValue";

export const getSchema = () => ({
  ...schema,
  properties: {
    ...schema.properties,
    multimedia: {
      ...schema.properties.multimedia,
      items: {
        ...schema.properties.multimedia.items,
        properties: {
          ...schema.properties.multimedia.items.properties,
        },
        additionalProperties: true,
      },
    },
  },
});

